import { WP_API_URL } from '../../../config'
import { languageApiFormatterUtil } from '@util/i18n/i18n'

const wpApiUrl = WP_API_URL

export interface WPPagesResponse {
  id: number
  date: Date
  date_gmt: Date
  guid: any
  modified: Date
  modified_gmt: Date
  slug: string
  status: string
  type: string
  link: string
  title: any
  content: any
  excerpt: any
  author: number
  featured_media: number
  parent: number
  menu_order: number
  comment_status: string
  ping_status: string
  template: string
  meta: any[]
  acf: any
  _links: any
}

const getTranslations = async (
  languageCode: string
): Promise<WPPagesResponse[]> => {
  const language = languageApiFormatterUtil(languageCode)
  const response = await fetch(wpApiUrl + `wp/v2/pages?lang=${language}`, {})
  return response.json()
}

export { getTranslations }
